import { render } from "./recargasCarier.vue?vue&type=template&id=1c221b99&scoped=true"
import script from "./recargasCarier.vue?vue&type=script&lang=js"
export * from "./recargasCarier.vue?vue&type=script&lang=js"

import "./recargasCarier.vue?vue&type=style&index=0&id=1c221b99&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c221b99"]])

export default __exports__